import React, { createContext, ReactElement, useContext } from 'react';
import { UpdateTextBlock } from 'use-case/widget/update/updateTextBlockUseCase';
import { CreateTextBlock } from 'use-case/widgets/create/createTextBlockUseCase';
import { DeleteTextBlock } from 'use-case/widgets/delete/deleteTextBlockUseCase';

export type TextBlockDispatch = {
    createTextBlock: CreateTextBlock;
    updateTextBlock: UpdateTextBlock;
    deleteTextBlock: DeleteTextBlock;
};

export type TextBlockProviderType = {
    createTextBlock: CreateTextBlock;
    updateTextBlock: UpdateTextBlock;
    deleteTextBlock: DeleteTextBlock;
    children: ReactElement;
};

export const TextBlockContext = createContext({} as TextBlockDispatch);

export const useTextBlock = (): TextBlockDispatch => useContext(TextBlockContext);

export const TextBlockProvider = (props: TextBlockProviderType): ReactElement => {
    const { children, createTextBlock, updateTextBlock, deleteTextBlock } = props;

    return (
        <TextBlockContext.Provider
            value={{
                createTextBlock,
                updateTextBlock,
                deleteTextBlock,
            }}
        >
            {children}
        </TextBlockContext.Provider>
    );
};

export default useTextBlock;